angular.module('controllers').controller('loyaltyPointController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/loyalty-point';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'loyalty-point';
		$scope.pathTemplate = 'discounts/loyaltypoints';
		$scope.title = 'Puncte de fidelizare';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		//$scope.minDate = new Date();
		//$scope.maxDate = new Date();
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

		$scope.sortType = 'client_name';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
			'client_phone':{'label':'Telefon client', 'filter':1, 'filterType':'input'},
			'client_name':{'label':'Nume client', 'filter':1, 'filterType':'input'},
			'loyalty_point_accumulated':{'label':'Puncte acumulate', 'filter':1, 'filterType':'input'},
			'loyalty_point_paid':{'label':'Puncte acordate', 'filter':1, 'filterType':'input'}
		};

		$scope.additionals['content_type'] = 'form-urlencoded';

		/* get dependent fields */
		/*$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['discounts'] = data.discounts;

					/!*if (!angular.isUndefined($scope.columns.shipping_method_name)) {
						$scope.columns.shipping_method_name.options = [{id: '', value: ''}];
						angular.forEach(data.shippingMethods, function (item, key) {
							$scope.columns.shipping_method_name.options.push({
								id: item.shipping_method_name,
								value: item.shipping_method_name
							});
						});
					}*!/

				});
		}*/

		/* close field */
		$scope.additionals['closeField'] = function (paramName, paramId, model, key) {
			if (!angular.isUndefined(key)) {
				model[key][paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[key][paramId] = '';
				}
			} else {
				model[paramName] = '';
				if (!angular.isUndefined(paramId)) {
					model[paramId] = '';
				}
			}
		}

		$scope.additionals['clients'] = [];
		$scope.additionals['getClients'] = function (search) {
			if (!angular.isUndefined(search)) {
				if (search != '' && search != 'undefined' && search.length >= 2) {
					var pathClient = 'search=' + search;
				}
			}

			$scope.additionals['errors'] = {};
			if (!angular.isUndefined($scope.errors)) {
				$scope.errors['client_id'] = {};
			}
			if (!angular.isUndefined(pathClient) && pathClient != 'undefined') {
				return Crud.get($scope.path + '/getClients?' + pathClient)
					.then(function (data) {
						$scope.additionals['clients'] = data.data.clients;
						return data.data.clients;
					});
			} else {
				return [];
			}

		}

		$scope.additionals['changeDiscountCampaignType'] = function(modelData) {
			if(modelData.discount_campaign_type == 0) {
				modelData.discount_campaign_times = 1;
			}
		}

		$scope.additionals['function'] = function(ev, data) {
			$scope.additionals['selectedItemClientPhone'] = '';
			$scope.additionals['selectedItemClientPhoneSearch'] = '';
			$scope.additionals['loyalty_point_history_all'] = [];

			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemClientPhoneMultiple'] = [];
			}
		}

		$scope.additionals['functionResult'] = function(ev, data) {

		}

		$scope.additionals['getAllHistory'] = function(model) {
			$scope.additionals['buttonDisabled'] = true;
			$scope.isLoading = true;
			Crud.get($scope.path + '/getAllHistory?client_id='+model['client_id'])
				.success(function (data) {
					$scope.additionals['buttonDisabled'] = false;
					$scope.isLoading = false;
					$scope.additionals['loyalty_point_history_all'] = data;
				});
		}


	}]
)
